import { z } from 'zod';
import { zId, zMoney, zInstant } from './primitives.js';

/** OR-02. Terminal states: CANCELLED, REJECTED, EXPIRED. */
export const orderStatuses = [
  'SUBMITTED', 'UNDER_REVIEW', 'AWAITING_ACCEPTANCE', 'APPROVED', 'AWAITING_ADVANCE',
  'IN_MANUFACTURING', 'READY', 'SHIPPED', 'DELIVERED',
  'CANCELLED', 'REJECTED', 'EXPIRED',
] as const;
export const zOrderStatus = z.enum(orderStatuses);
export type OrderStatus = z.infer<typeof zOrderStatus>;

/** OR-04b — submitted values retained alongside negotiated so variance is auditable. */
export const zOrderLine = z.object({
  variantCode: z.string().min(1),
  quantity: z.number().int().positive(),
  submittedUnitPrice: zMoney,
  agreedUnitPrice: zMoney,
});

export const zOrder = z.object({
  id: zId,
  reference: z.string(),
  portalId: zId,
  retailerId: zId,
  status: zOrderStatus,
  submittedAt: zInstant,
  /** FN-06 — frozen at creation, never recalculated. */
  exchangeRate: z.string(),
  currency: z.string().length(3),
  submittedTotal: zMoney,
  agreedTotal: zMoney,
  advanceRequired: zMoney,
  /** OR-13 — lapses to EXPIRED if unanswered. */
  acceptanceExpiresAt: zInstant.nullable(),
  lines: z.array(zOrderLine).min(1),
});
export type Order = z.infer<typeof zOrder>;
